export const config = {
    apiKey: "AIzaSyBODxwvahtJR8YX42oQveopGWXmx-cxPHA",
    authDomain: "cansatweb-1547364100927.firebaseapp.com",
    databaseURL: "https://cansatweb-1547364100927.firebaseio.com",
    projectId: "cansatweb-1547364100927",
    storageBucket: "cansatweb-1547364100927.appspot.com",
    messagingSenderId: "714367302307"
};